<div class="flex gap-3 flex-wrap mt-3">
    <div class="flex-nowrap flex gap-2 align-items-center" *ngIf="questionPageHiddenLog > 0">
        <img src="assets/vinter/icons/cheating-icon.svg">
        <p class="font-medium page-hidden">{{"Key.SwitchTab" | translate: {value: questionPageHiddenLog } }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.isFaceDetected && answer?.isAllowedDifferentFaceAnalysis" class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/face-detection-icon.svg" class="detect-img">
        <p class="font-medium face-detected">{{"Key.FaceDetected" | translate }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.isMultiFaceDetected && answer?.isAllowedMultipleFaceAnalysis" class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/multiface-detected-icon.svg" class="detect-img">
        <p class="font-medium multiface-detected">{{"Key.MultiFaceDetected" | translate }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.improprietyAnalysis?.isImproprietySpeech && answer?.isAllowedImproprietySpeechAnalysis" class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/impropriety-speech-warning.svg" class="detect-img">
        <p class="font-medium impropriety-speech">{{"Key.ImproprietySpeechAnalysis" | translate }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace ||
     answer?.answerContent?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace" class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/face-detection-status-icon.svg" class="detect-img">
        <p class="font-medium impropriety-speech">{{"Key.FaceDetectionStatus" | translate }}</p>
    </div>
</div>

<div class="flex">
    <img src="assets/vinter/icons/text-questioncoktan-secmeli-cevap-icon-arrow-back-up.svg">
    <h5 class="text-justify answer-title font-semibold text-lg ml-2">
        {{"Key.Answer" | translate}}
    </h5>
</div>

<div class="ml-5 flex" *ngIf="answer === null">
    <img src="assets/vinter/icons/not-answered.svg">
    <p class="ml-2 empty-answer-text">{{"Key.ThisTypeQuestionNotAnswered" | translate}}</p>
</div>

<div *ngIf="answer?.answerContent" class="grid lg:ml-4 lg:-mr-2">
    <div class="col-12 md:col-12 lg:col-6 lg:px-2 w-full flex flex-wrap">
        <div class="flex flex-wrap flex-row align-items-start answer-container border-1 border-solid border-gray-50 border-round-md p-3 justify-content-center">
            <div class="custom-col-6 height-fit justify-content-center">
                <vg-player *ngIf="answer?.answerContent.contentURL ?? false" style="border-radius: 15px; background-color:transparent">
                    <video #speakingVideo [vgMedia]="$any(speakingMedia)" #speakingMedia id="speakingVideo" preload="auto"
                        controls (timeupdate)="highlightSpeaking($event.target)">
                        <source [src]="answer?.answerContent.contentURL" type="video/webm">
                        <source [src]="answer?.answerContent.contentURL" type="video/mp4">
                    </video>
                </vg-player>
            </div>
        </div>
    </div>
</div>